import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./EmptyViewMessage.module.scss";
import {FontIcon, Icon} from "../FontIcon";
import Button from "../Button";

export interface IEmptyViewMessage {
  icon: Icon,
  message: string,
  buttonText?: string,
  buttonClickHandler?: () => void,
}

export const EmptyViewMessage: VoidFunctionComponent<IEmptyViewMessage> = ({
  icon,
  message,
  buttonText,
  buttonClickHandler,
}) => {
  return (
    <div className={s.emptyViewMessage} role={"status"}>
      <FontIcon icon={icon} />
      <h3 className={s.messageText}>{message}</h3>
      {buttonText && buttonClickHandler ?
        <Button buttonType={"primary"} text={buttonText} onClick={buttonClickHandler} />
        : null
      }
    </div>
  );
}
